import React, {lazy} from 'react'
import {Route, Router, Switch, Link} from 'react-router-dom'
import {ResetCSS} from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'
import useUserAgent from './hooks/useUserAgent'
import useScrollOnRouteChange from './hooks/useScrollOnRouteChange'
import Disclaimer from './views/Terms/Disclaimer'
import {useUpdateNetwork} from './state/network/hooks'
import {DatePickerPortal} from './components/DatePicker'

import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import {ToastListener} from './contexts/ToastsContext'
import PageLoader from './components/Loader/PageLoader'
import GlobalCheckClaimStatus from './components/GlobalCheckClaimStatus'
import history from './routerHistory'
import {hasCurrentWalletPermission, Permissions} from "~/utils/permissions";
import {useAccount} from "wagmi";

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page
const Home = lazy(() => import('./views/Home'))
const NotFound = lazy(() => import('./views/NotFound'))
const LPBurn = lazy(() => import('./views/LPBurn'))
const Farms = lazy(() => import('./views/LPOverview'))
const Pools = lazy(() => import('./views/LPClaim'))
const PersonalClaim = lazy(() => import('./views/PersonalClaim'))
const Personaltransactions = lazy(() => import('./views/PersonalTransactions'))
const Stats = lazy(() => import('./views/LPStats'))
const Vaults = lazy(() => import('./views/Vaults'))

// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  useUpdateNetwork()
  // usePollBlockNumber()
  // useEagerConnect()
  // usePollCoreFarmData()
  useScrollOnRouteChange()
  useUserAgent()
  const {address} = useAccount()

  const loadMenuAndRoutes = () => {
    if (!address) {
      history.push('/')
    }

    return (
      <Menu>
        <SuspenseWithChunkError fallback={<PageLoader/>}>
          <Switch>
            <Route path="/" exact>
              <Home/>
            </Route>
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF]) &&
              <Route path="/lpburn" exact>
                <LPBurn/>
              </Route>
            }
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF]) &&
              <Route path="/lpoverview" exact>
                <Farms/>
              </Route>
            }
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF]) &&
              <Route path="/lpclaim" exact>
                <Pools/>
              </Route>
            }
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF, Permissions.INVESTOR]) &&
              <Route path="/personalclaim" exact>
                <PersonalClaim/>
              </Route>
            }
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF, Permissions.STAFF]) &&
              <Route path="/personaltransactions" exact>
                <Personaltransactions/>
              </Route>
            }
            {
              hasCurrentWalletPermission(address, [Permissions.STAFF, Permissions.STATISTICS]) &&
              <Route path="/lpstats" exact>
                <Stats/>
              </Route>
            }
            <Route path="/vaults" exact>
              <Vaults/>
            </Route>
            <Route component={NotFound}/>
          </Switch>
        </SuspenseWithChunkError>
      </Menu>
    )
  }

  return (
    <Router history={history}>
      <Disclaimer/>
      <ResetCSS/>
      <GlobalStyle/>
      <GlobalCheckClaimStatus excludeLocations={[]}/>
      {loadMenuAndRoutes()}
      <ToastListener/>
      <DatePickerPortal/>
    </Router>
  )
}


export default React.memo(App)
